var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,4.2C28.4,4.2,3.1,29.6,3.1,60.9c0,25,16.2,46.2,38.7,53.7c2.8,0.5,3.9-1.2,3.9-2.7c0-1.3,0-4.9-0.1-9.6 c-15.8,3.4-19.1-7.6-19.1-7.6c-2.6-6.5-6.3-8.3-6.3-8.3c-5.1-3.5,0.4-3.4,0.4-3.4c5.7,0.4,8.7,5.8,8.7,5.8 c5.1,8.7,13.3,6.2,16.5,4.7c0.5-3.7,2-6.2,3.6-7.6c-12.6-1.4-25.8-6.3-25.8-28c0-6.2,2.2-11.2,5.8-15.2c-0.6-1.4-2.5-7.2,0.6-15 c0,0,4.8-1.5,15.6,5.8c4.5-1.3,9.4-1.9,14.2-1.9s9.7,0.7,14.2,1.9c10.8-7.3,15.6-5.8,15.6-5.8c3.1,7.8,1.1,13.6,0.6,15 c3.6,4,5.8,9,5.8,15.2c0,21.8-13.2,26.5-25.9,27.9c2,1.7,3.8,5.2,3.8,10.5c0,7.6-0.1,13.7-0.1,15.5c0,1.5,1,3.3,3.9,2.7 c22.5-7.5,38.7-28.7,38.7-53.7C116.3,29.6,91,4.2,59.7,4.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c18414df8c78db60cdaf97e74647841c.svg";
export { ForwardRef as ReactComponent };